import { FADE_SIZE } from '@/shared/components/ui/scroll-fade/scroll-fade.constants';
import { TScrollFadeMaskProps } from '@/shared/components/ui/scroll-fade/scroll-fade.types';

// Fades the content to transparent only on the edge that has clipped content,
// so it blends into whatever background the scroll area sits on.
export const getScrollFadeMask = ({
  $fadeTop,
  $fadeBottom,
}: TScrollFadeMaskProps) => {
  if (!$fadeTop && !$fadeBottom) {
    return 'none';
  }

  const start = $fadeTop ? 'transparent 0' : 'black 0';
  const end = $fadeBottom ? 'transparent 100%' : 'black 100%';

  return `linear-gradient(to bottom, ${start}, black ${FADE_SIZE}, black calc(100% - ${FADE_SIZE}), ${end})`;
};
